





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class QuickChangeInput extends Vue {
  @Prop({ type: String, default: "" }) text!: string;
  data = this.text;

  @Watch("text")
  update(): void {
    this.data = this.text;
  }
}
